import { lazy } from 'react';

const LoginPage = lazy(() => import('./pages/LoginPage'));

export const authRoutes = [
  {
    path: '/login',
    element: LoginPage,
    permission: null,
    public: true,
    nav: null,
  },
];
